import { useFFContext } from '@/components/OpenFeature/hooks/useFFContext';
import { Wrapper } from '@/components/OpenFeature/Wrapper';
import { INVOICE_REPORT_MULTIPLE_SORT_BY_DATETIME_FLAG_KEY } from '@/hooks/feature_flag/useInvoiceReportMultipleSortByDatetimeFlag';
import { OpenFeatureProvider } from '@moneyforward/user-flex-feature-hooks';
import { FC } from 'react';
import { ApprovingInvoiceReports as ApprovingInvoiceReportsList } from './components/List';

export const ApprovingInvoiceReports: FC = () => {
  const ffContext = useFFContext();
  return (
    <Wrapper isProto={false}>
      <OpenFeatureProvider
        pollInterval={-1}
        context={ffContext}
        domain='ap-payment-request-support-agent'
      >
        <OpenFeatureProvider
          pollInterval={-1}
          context={ffContext}
          domain={INVOICE_REPORT_MULTIPLE_SORT_BY_DATETIME_FLAG_KEY}
        >
          <ApprovingInvoiceReportsList />
        </OpenFeatureProvider>
      </OpenFeatureProvider>
    </Wrapper>
  );
};
